export const finitePrice = value => {
  const number = Number.parseFloat(value);
  return Number.isFinite(number) ? number : null;
};

// Never derive a historical unit cost from today's packaging.
export const historicalUnitPurchasePrice = (item, field = 'price_purchase') => {
  const fields = {
    price_purchase: 'purchase_unit_price_amount',
    purchase_prices_avg_amount: 'purchase_prices_avg_unit_amount',
    weighted_purchase_price_amount: 'weighted_purchase_unit_price_amount',
  };
  return finitePrice(item?.[fields[field]]);
};

export const purchaseUnitStatistics = (item = {}) => ({
  current: finitePrice(item.purchase_unit_price_amount),
  average: finitePrice(item.purchase_prices_avg_unit_amount),
  weighted: finitePrice(item.weighted_purchase_unit_price_amount),
  missingPriceSnapshots: Number(item.purchase_prices_missing_snapshot_count) || 0,
  missingReceiptSnapshots: Number(item.weighted_purchase_missing_snapshot_count) || 0,
});

export const hasMissingPurchaseSnapshots = item => (Number(item?.purchase_prices_missing_snapshot_count) || 0) > 0
  || (Number(item?.weighted_purchase_missing_snapshot_count) || 0) > 0
  || (finitePrice(item?.price_purchase) > 0 && historicalUnitPurchasePrice(item) === null);
